<template>
    <div v-if="loading" class="state-changed w-full h-20 fixed border-0 top-0 left-0 z-50"></div>

    <div class="w-full mb-4 -mt-2 relative">
        <router-link v-if="!noarrow" :to="'/Settings'">
            <font-awesome-icon icon="fas fa-arrow-left" class="absolute float-left text-lg p-2 text-button dark:text-dark.textOnBkg -mt-2" />
        </router-link>
        <h2 class="text-xl text-contentText font-semibold text-center dark:text-growth">{{ $t('group_settings.headline') }}</h2>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-10 mt-5 max-w-screen-lg">
        <section class="hidden relative sm:block">
            {{$t('group_settings.p[0]')}}<br />

            <div class="mt-2"><span class="text-button dark:text-growth">{{$t('group_settings.steps.h[0]')}}:</span> {{$t('group_settings.steps.span[0]')}}</div>
            <div class="mt-2"><span class="text-button dark:text-growth">{{$t('group_settings.steps.h[1]')}}:</span> {{$t('group_settings.steps.span[1]')}}</div>
            <div class="mt-5 text-lg"><strong>{{$t('group_settings.steps.h[2]')}}:</strong></div>

            <div class="mt-2"><span class="text-button dark:text-growth">{{$t('group_settings.steps.h[3]')}}:</span>{{$t('group_settings.steps.span[2]')}}</div>

            <div class="mt-2"><span class="text-button dark:text-growth">{{ $t('group_settings.steps.h[4]') }}:</span>{{$t('group_settings.steps.span[3]')}} </div>

            <div class="mt-5"><strong class="text-lg">{{ $t('group_settings.steps.h[5]') }}:</strong></div>

            <div class="mt-2"><span class="text-button dark:text-growth">{{ $t('Creators') }}:</span> {{$t('group_settings.steps.span[4]')}}</div>
            <div class="mt-2"><span class="text-button dark:text-growth">{{ $t('group_settings.steps.h[6]') }}:</span> {{$t('group_settings.steps.span[5]')}}</div>
            <div class="mt-2"><span class="text-button dark:text-growth">{{ $t('group_settings.steps.h[7]') }}:</span> {{$t('group_settings.steps.span[6]')}}</div>
            <div class="mt-2"><span class="text-button dark:text-growth">{{ $t('group_settings.steps.h[8]') }}:</span> {{$t('group_settings.steps.span[7]')}}</div>
        </section>
        <ol class="text-contentText w-80 leading-8">
            <li v-for="(group, groupIndex) in groups" :key="group.id">
                <group-label :team="group" is_group="1" :showDelete="!group.hasChildren" :groupIndex="groupIndex" @remove-prop="handleRemoval(null,groupIndex)" />

                <ul v-if="group.hasChildren">
                    <draggable v-model="group.children" group="people" 
                    @start="drag=true" 
                    @end="drag=false" 
                    item-key="id"
                    @change="reorderCallBack">
                    <template #item="{element, index}">
                        <group-label :team="element" is_group="0" :showDelete="true" :teamIndex="index" @remove-prop="handleRemoval(index,groupIndex)" />
                    </template>
                    </draggable>
                    <add-group-component class="ml-8" label="New team" type="team" :groupID="group.id" @newGroup="(newGroupName, newTeamId) => handleNewGroup(newGroupName, newTeamId, group.id)" />
                </ul>

                <ul v-else class="pl-8">
                    <add-group-component label="New team" type="team" :groupID="group.id" @newGroup="(newGroupName, newTeamId) => handleNewGroup(newGroupName, newTeamId, group.id)" />
                </ul>
                <hr class="border border-sepBorder dark:border-dark.sepBorder mt-4"/>
            </li>

            <add-group-component class="mt-4" label="New group" type="team" :groupID="null" @newGroup="(newGroupName, newTeamId) => handleNewGroup(newGroupName, newTeamId)" />
        </ol>
    </div>
    
</template>

<script setup>
    import draggable from 'vuedraggable'
    import addGroupComponent from './add_group_component.vue';
    import groupLabel from './group_label.vue';
</script>

<script>
    import { get_groups, reorder_groups } from '@/api/api';
    export default {
        components: {addGroupComponent,groupLabel,draggable},
        props: ['headerName', 'noarrow'],
        data() {
            return {
                groups: [],
                loading: false,
                drag: false,
            }  
        }, 
        methods: {
            async reorderCallBack(){
                await reorder_groups(this.$cookies.get("userToken"),this.$cookies.get('c_id'),this.groups);
            },
            handleRemoval(teamIndex,groupIndex) {
                if (teamIndex != null) {
                    this.groups[groupIndex].children.splice(teamIndex, 1);
                    if (this.groups[groupIndex].children.length == 0) {
                        this.groups[groupIndex].hasChildren = false;
                    }
                } else {
                    this.groups.splice(groupIndex, 1);
                }
            },
            handleNewGroup(newGroupName, newTeamId, groupId = null) {
                if (groupId) {
                    const groupToUpdate = this.groups.find(group => group.id === groupId);
                    
                    if (groupToUpdate) {
                        if (!groupToUpdate.children) {
                            groupToUpdate.children = [];
                        }
                        groupToUpdate.hasChildren = true;
                        groupToUpdate.children.push({
                            id: newTeamId,
                            name: newGroupName,
                            hasChildren: false
                        });
                    } else {
                        console.error("Group with given ID not found.");
                    }
                } else {
                    this.groups.push({
                        id: newTeamId,
                        name: newGroupName,
                        hasChildren: false,
                        children: []
                    });
                }
            }
        },
        async created() {
            this.loading = true;
            this.groups = await get_groups(this.$cookies.get("userToken"),this.$cookies.get('c_id'));
            console.log(this.groups);
            this.loading = false;
        }
    }
</script>





